import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Loader from './components/Loader/Loader';
import Login from './components/Login/Login';
import Recuperar from './components/Login/Recuperar';

import Header from './components/Header/Header';
import Sidebar from './components/Sidebar/Sidebar';
import Main from './components/Main/Init'
import Footer from './components/Footer/Footer';

import Structure from './components/WEBContent/Structure/Init'

import Utilizador from './components/Entities/Utilizador/Init'
import Instrutor from './components/Entities/Instrutor/Init'
import Colaborador from './components/Entities/Colaborador/Init'
import Cliente from './components/Entities/Cliente/Init'
import Company from './components/Entities/Company/Init'

//import Corporate from './components/Corporate/Corporate'
import TermosCondicoes from './components/Termos/TermosCondicoes'
import PoliticaPrivacidade from './components/Termos/PoliticaPrivacidade'

import Calendar_Event from './components/Calendar/Event/Init'
import Calendar_Category from './components/Calendar/Category/Init'

import Content from './components/WEBContent/Content/Init'
import Content_News from './components/WEBContent/News/Init'
import Content_Banner from './components/WEBContent/Banner/Init'
import Content_Gallery from './components/WEBContent/Gallery/Init'
import Content_Testemony from './components/WEBContent/Testemony/Init'
import Content_Category from './components/WEBContent/Category/Init'

import Content_Contest from './components/WEBContent/Contest/Init'

/*import Project from './components/Project/Content/Init'
import Project_Area from './components/Project/Area/Init'
import Project_Program from './components/Project/Program/Init'
import Project_Domain from './components/Project/Domain/Init'
import Project_Scope from './components/Project/Scope/Init'
import Project_Fund from './components/Project/Fund/Init'*/

import Store_Product from './components/Store/Product/Init'
import Store_Category from './components/Store/Category/Init'
import Store_Category_Value from './components/Store/Category/Value/Init'
import Store_Attribute from './components/Store/Attribute/Init'
import Store_Attribute_Value from './components/Store/Attribute/Value/Init'
import Store_Feature from './components/Store/Feature/Init'
import Store_Feature_Value from './components/Store/Feature/Value/Init'
import Store_Brand from './components/Store/Brand/Init'
import Store_Brand_Value from './components/Store/Brand/Value/Init'
import Store_Preferences from './components/Store/Shipping/Preferences/Init'
import Store_Shipping_Carrier from './components/Store/Shipping/Carrier/Init'
import Store_Shipping_Zone from './components/Store/Shipping/Zone/Init'
import Store_Shipping_Country from './components/Store/Shipping/Country/Init'
import Store_Taxe from './components/Store/Shipping/Taxe/Init'

import Estancia_Config from './components/Estancia/Config/Init'
import Estancia_Meios from './components/Estancia/Meios/Init'
import Estancia_Pista from './components/Estancia/Pista/Init'
import Estancia_Forfait from './components/Estancia/Forfait/Init'
import Estancia_Equipamento from './components/Estancia/Equipamento/Init'
import Estancia_Voucher from './components/Estancia/Voucher/Init'
import Estancia_Pack from './components/Estancia/Pack/Init'
import Estancia_Aula from './components/Estancia/Aula/Init'
import Estancia_AulaInfo from './components/Estancia/AulaInfo/Init'
import Estancia_Zona from './components/Estancia/Zona/Init'
import Estancia_Atividade from './components/Estancia/Atividade/Init'
import Estancia_PurchaseOrder from './components/Estancia/PurchaseOrder/Init'
import Estancia_PurchaseOrderPaied from './components/Estancia/PurchaseOrderPaied/Init'
import Estancia_PurchaseOrderUsed from './components/Estancia/PurchaseOrderUsed/Init'
import Estancia_PurchaseOrderNotUsed from './components/Estancia/PurchaseOrderNotUsed/Init'
import Estancia_Oferta from './components/Estancia/Oferta/Init'

import Perfil from './components/WEBContent/PerfisMenus/Init'



import useToken from './UseToken';

import {
  set_language,
  repo_favicon_link,
} from './Utils';

document.title = `${document.title}`

//if (process.env.REACT_APP_MODE === 'production') console.log = function () { };

function App() {

  const { token, setToken } = useToken();

  const [isloading, setLoading] = useState(true);

  const handleFavIcon = () => {
    function getFaviconEl() {
      return document.getElementById("favicon");
    }

    const favicon = getFaviconEl(); // Accessing favicon element

    favicon.href = repo_favicon_link("favicon.ico");
  };

  handleFavIcon()


  const change_lang = (l) => {
    set_language(l)
    window.location.reload()

    //console.log('language', localStorage.getItem('lang'))
    //console.log('localstorage', localStorage)
  }

  useEffect(() => {
    if(localStorage.getItem('lang') !== undefined  && localStorage.getItem('lang') !== null && localStorage.getItem('lang') !== 'pt') {
      change_lang('pt')
    }

    if(token) {
      setLoading(false)
    }

    return () => { };

  }, [token])

  if (!token) {
    //console.log('---> APP.JS: ANTES DO TOKEN')
    return <Login setToken={setToken} />
  }

  let checkAuthorization = (path, component) => {
    return component
  }

  return isloading ?
    <Loader />
    :
    <>
      <Header />
      <Sidebar
      /*
      sidebar_info = {
        sideBarData
      }
      */
      />
      <div className="main-content">

        <Switch>

          <Route path={Main.view.endpoint} exact
            component={checkAuthorization(Main.view, Main.view.component)}
          />

          <Route path={Structure.regist.endpoint} exact
            component={checkAuthorization(Structure.regist.endpoint, Structure.regist.component)}
          />

          <Route path={Structure.list.endpoint} exact
            component={checkAuthorization(Structure.list.endpoint, Structure.list.component)}
          />

          <Route path={Structure.view.endpoint} exact
            component={checkAuthorization(Structure.view.endpoint, Structure.view.component)}
          />

          <Route path={Utilizador.regist.endpoint} exact
            component={checkAuthorization(Utilizador.regist.endpoint, Utilizador.regist.component)}
          />

          <Route path={Utilizador.list.endpoint} exact
            component={checkAuthorization(Utilizador.list.endpoint, Utilizador.list.component)}
          />

          <Route path={Utilizador.view.endpoint} exact
            component={checkAuthorization(Utilizador.view.endpoint, Utilizador.view.component)}
          />

          <Route path={Instrutor.regist.endpoint} exact
            component={checkAuthorization(Instrutor.regist.endpoint, Instrutor.regist.component)}
          />

          <Route path={Instrutor.list.endpoint} exact
            component={checkAuthorization(Instrutor.list.endpoint, Instrutor.list.component)}
          />

          <Route path={Instrutor.view.endpoint} exact
            component={checkAuthorization(Instrutor.view.endpoint, Instrutor.view.component)}
          />

          <Route path={Instrutor.scale.endpoint} exact
            component={checkAuthorization(Instrutor.scale.endpoint, Instrutor.scale.component)}
          />

          <Route path={Colaborador.regist.endpoint} exact
            component={checkAuthorization(Colaborador.regist.endpoint, Colaborador.regist.component)}
          />

          <Route path={Colaborador.list.endpoint} exact
            component={checkAuthorization(Colaborador.list.endpoint, Colaborador.list.component)}
          />

          <Route path={Colaborador.view.endpoint} exact
            component={checkAuthorization(Colaborador.view.endpoint, Colaborador.view.component)}
          />

          <Route path={Cliente.regist.endpoint} exact
            component={checkAuthorization(Cliente.regist.endpoint, Cliente.regist.component)}
          />

          <Route path={Cliente.list.endpoint} exact
            component={checkAuthorization(Cliente.list.endpoint, Cliente.list.component)}
          />

          <Route path={Cliente.view.endpoint} exact
            component={checkAuthorization(Cliente.view.endpoint, Cliente.view.component)}
          />


          <Route path={Company.components.base.path} exact
            component={checkAuthorization(Company.components.base.path, Company.components.base.component)}
          />

          <Route path={Company.components.regist.path} exact
            component={checkAuthorization(Company.components.list.path, Company.components.regist.component)}
          />

          <Route path={Company.components.view.path} exact
            component={checkAuthorization(Company.components.view.path, Company.components.view.component)}
          />




          <Route path={Calendar_Event.view.endpoint} exact
            component={checkAuthorization(Calendar_Event.view, Calendar_Event.view.component)}
          />

          <Route path={Calendar_Category.list.endpoint} exact
            component={checkAuthorization(Calendar_Category.list, Calendar_Category.list.component)}
          />

          <Route path={Calendar_Category.view.endpoint} exact
            component={checkAuthorization(Calendar_Category.view, Calendar_Category.view.component)}
          />

          <Route path={Calendar_Category.regist.endpoint} exact
            component={checkAuthorization(Calendar_Category.regist, Calendar_Category.regist.component)}
          />

          <Route path={Content.list.endpoint} exact
            component={checkAuthorization(Content.list, Content.list.component)}
          />

          <Route path={Content.view.endpoint} exact
            component={checkAuthorization(Content.view, Content.view.component)}
          />

          <Route path={Content.regist.endpoint} exact
            component={checkAuthorization(Content.regist, Content.regist.component)}
          />

          <Route path={Content_Category.list.endpoint} exact
            component={checkAuthorization(Content_Category.list, Content_Category.list.component)}
          />

          <Route path={Content_Category.view.endpoint} exact
            component={checkAuthorization(Content_Category.view, Content_Category.view.component)}
          />

          <Route path={Content_Category.regist.endpoint} exact
            component={checkAuthorization(Content_Category.regist, Content_Category.regist.component)}
          />

          <Route path={Content_News.list.endpoint} exact
            component={checkAuthorization(Content_News.list, Content_News.list.component)}
          />

          <Route path={Content_News.view.endpoint} exact
            component={checkAuthorization(Content_News.view, Content_News.view.component)}
          />

          <Route path={Content_News.regist.endpoint} exact
            component={checkAuthorization(Content_News.regist, Content_News.regist.component)}
          />

          <Route path={Content_Banner.list.endpoint} exact
            component={checkAuthorization(Content_Banner.list, Content_Banner.list.component)}
          />

          <Route path={Content_Banner.view.endpoint} exact
            component={checkAuthorization(Content_Banner.view, Content_Banner.view.component)}
          />

          <Route path={Content_Banner.regist.endpoint} exact
            component={checkAuthorization(Content_Banner.regist, Content_Banner.regist.component)}
          />

          <Route path={Content_Gallery.list.endpoint} exact
            component={checkAuthorization(Content_Gallery.list, Content_Gallery.list.component)}
          />

          <Route path={Content_Gallery.view.endpoint} exact
            component={checkAuthorization(Content_Gallery.view, Content_Gallery.view.component)}
          />

          <Route path={Content_Gallery.regist.endpoint} exact
            component={checkAuthorization(Content_Gallery.regist, Content_Gallery.regist.component)}
          />

          <Route path={Content_Testemony.list.endpoint} exact
            component={checkAuthorization(Content_Testemony.list, Content_Testemony.list.component)}
          />

          <Route path={Content_Testemony.view.endpoint} exact
            component={checkAuthorization(Content_Testemony.view, Content_Testemony.view.component)}
          />

          <Route path={Content_Testemony.regist.endpoint} exact
            component={checkAuthorization(Content_Testemony.regist, Content_Testemony.regist.component)}
          />

          <Route path={Content_Contest.list.endpoint} exact
            component={checkAuthorization(Content_Contest.list, Content_Contest.list.component)}
          />

          <Route path={Content_Contest.view.endpoint} exact
            component={checkAuthorization(Content_Contest.view, Content_Contest.view.component)}
          />

          <Route path={Content_Contest.regist.endpoint} exact
            component={checkAuthorization(Content_Contest.regist, Content_Contest.regist.component)}
          />

          {/*<Route path={Project.list.endpoint} exact
            component={checkAuthorization(Project.list, Project.list.component)}
          />

          <Route path={Project.view.endpoint} exact
            component={checkAuthorization(Project.view, Project.view.component)}
          />

          <Route path={Project.regist.endpoint} exact
            component={checkAuthorization(Project.regist, Project.regist.component)}
          />

          <Route path={Project_Area.list.endpoint} exact
            component={checkAuthorization(Project_Area.list, Project_Area.list.component)}
          />

          <Route path={Project_Area.view.endpoint} exact
            component={checkAuthorization(Project_Area.view, Project_Area.view.component)}
          />

          <Route path={Project_Area.regist.endpoint} exact
            component={checkAuthorization(Project_Area.regist, Project_Area.regist.component)}
          />

          <Route path={Project_Domain.list.endpoint} exact
            component={checkAuthorization(Project_Domain.list, Project_Domain.list.component)}
          />

          <Route path={Project_Domain.view.endpoint} exact
            component={checkAuthorization(Project_Domain.view, Project_Domain.view.component)}
          />

          <Route path={Project_Domain.regist.endpoint} exact
            component={checkAuthorization(Project_Domain.regist, Project_Domain.regist.component)}
          />

          <Route path={Project_Fund.list.endpoint} exact
            component={checkAuthorization(Project_Fund.list, Project_Fund.list.component)}
          />

          <Route path={Project_Fund.view.endpoint} exact
            component={checkAuthorization(Project_Fund.view, Project_Fund.view.component)}
          />

          <Route path={Project_Fund.regist.endpoint} exact
            component={checkAuthorization(Project_Fund.regist, Project_Fund.regist.component)}
          />

          <Route path={Project_Program.list.endpoint} exact
            component={checkAuthorization(Project_Program.list, Project_Program.list.component)}
          />

          <Route path={Project_Program.view.endpoint} exact
            component={checkAuthorization(Project_Program.view, Project_Program.view.component)}
          />

          <Route path={Project_Program.regist.endpoint} exact
            component={checkAuthorization(Project_Program.regist, Project_Program.regist.component)}
          />

          <Route path={Project_Scope.list.endpoint} exact
            component={checkAuthorization(Project_Scope.list, Project_Scope.list.component)}
          />

          <Route path={Project_Scope.view.endpoint} exact
            component={checkAuthorization(Project_Scope.view, Project_Scope.view.component)}
          />

          <Route path={Project_Scope.regist.endpoint} exact
            component={checkAuthorization(Project_Scope.regist, Project_Scope.regist.component)}
          />*/}

          <Route path={Store_Product.list.endpoint} exact
            component={checkAuthorization(Store_Product.list, Store_Product.list.component)}
          />

          <Route path={Store_Product.view.endpoint} exact
            component={checkAuthorization(Store_Product.view, Store_Product.view.component)}
          />

          <Route path={Store_Product.regist.endpoint} exact
            component={checkAuthorization(Store_Product.regist, Store_Product.regist.component)}
          />

          <Route path={Store_Category.list.endpoint} exact
            component={checkAuthorization(Store_Category.list, Store_Category.list.component)}
          />

          <Route path={Store_Category.view.endpoint} exact
            component={checkAuthorization(Store_Category.view, Store_Category.view.component)}
          />

          <Route path={Store_Category.regist.endpoint} exact
            component={checkAuthorization(Store_Category.regist, Store_Category.regist.component)}
          />

          <Route path={Store_Category_Value.list.endpoint} exact
            component={checkAuthorization(Store_Category_Value.list, Store_Category_Value.list.component)}
          />

          <Route path={Store_Category_Value.view.endpoint} exact
            component={checkAuthorization(Store_Category_Value.view, Store_Category_Value.view.component)}
          />

          <Route path={Store_Category_Value.regist.endpoint} exact
            component={checkAuthorization(Store_Category_Value.regist, Store_Category_Value.regist.component)}
          />

          <Route path={Store_Attribute.list.endpoint} exact
            component={checkAuthorization(Store_Attribute.list, Store_Attribute.list.component)}
          />

          <Route path={Store_Attribute.view.endpoint} exact
            component={checkAuthorization(Store_Attribute.view, Store_Attribute.view.component)}
          />

          <Route path={Store_Attribute.regist.endpoint} exact
            component={checkAuthorization(Store_Attribute.regist, Store_Attribute.regist.component)}
          />

          <Route path={Store_Attribute_Value.list.endpoint} exact
            component={checkAuthorization(Store_Attribute_Value.list, Store_Attribute_Value.list.component)}
          />

          <Route path={Store_Attribute_Value.view.endpoint} exact
            component={checkAuthorization(Store_Attribute_Value.view, Store_Attribute_Value.view.component)}
          />

          <Route path={Store_Attribute_Value.regist.endpoint} exact
            component={checkAuthorization(Store_Attribute_Value.regist, Store_Attribute_Value.regist.component)}
          />

          <Route path={Store_Feature.list.endpoint} exact
            component={checkAuthorization(Store_Feature.list, Store_Feature.list.component)}
          />

          <Route path={Store_Feature.view.endpoint} exact
            component={checkAuthorization(Store_Feature.view, Store_Feature.view.component)}
          />

          <Route path={Store_Feature.regist.endpoint} exact
            component={checkAuthorization(Store_Feature.regist, Store_Feature.regist.component)}
          />

          <Route path={Store_Feature_Value.list.endpoint} exact
            component={checkAuthorization(Store_Feature_Value.list, Store_Feature_Value.list.component)}
          />

          <Route path={Store_Feature_Value.view.endpoint} exact
            component={checkAuthorization(Store_Feature_Value.view, Store_Feature_Value.view.component)}
          />

          <Route path={Store_Feature_Value.regist.endpoint} exact
            component={checkAuthorization(Store_Feature_Value.regist, Store_Feature_Value.regist.component)}
          />

          <Route path={Store_Brand.list.endpoint} exact
            component={checkAuthorization(Store_Brand.list, Store_Brand.list.component)}
          />

          <Route path={Store_Brand.view.endpoint} exact
            component={checkAuthorization(Store_Brand.view, Store_Brand.view.component)}
          />

          <Route path={Store_Brand.regist.endpoint} exact
            component={checkAuthorization(Store_Brand.regist, Store_Brand.regist.component)}
          />

          <Route path={Store_Brand_Value.list.endpoint} exact
            component={checkAuthorization(Store_Brand_Value.list, Store_Brand_Value.list.component)}
          />

          <Route path={Store_Brand_Value.view.endpoint} exact
            component={checkAuthorization(Store_Brand_Value.view, Store_Brand_Value.view.component)}
          />

          <Route path={Store_Brand_Value.regist.endpoint} exact
            component={checkAuthorization(Store_Brand_Value.regist, Store_Brand_Value.regist.component)}
          />

          <Route path={Store_Preferences.regist.endpoint} exact
            component={checkAuthorization(Store_Preferences.regist, Store_Preferences.regist.component)}
          />

          <Route path={Store_Shipping_Carrier.list.endpoint} exact
            component={checkAuthorization(Store_Shipping_Carrier.list, Store_Shipping_Carrier.list.component)}
          />

          <Route path={Store_Shipping_Carrier.view.endpoint} exact
            component={checkAuthorization(Store_Shipping_Carrier.view, Store_Shipping_Carrier.view.component)}
          />

          <Route path={Store_Shipping_Carrier.regist.endpoint} exact
            component={checkAuthorization(Store_Shipping_Carrier.regist, Store_Shipping_Carrier.regist.component)}
          />

          <Route path={Store_Shipping_Zone.list.endpoint} exact
            component={checkAuthorization(Store_Shipping_Zone.list, Store_Shipping_Zone.list.component)}
          />

          <Route path={Store_Shipping_Zone.view.endpoint} exact
            component={checkAuthorization(Store_Shipping_Zone.view, Store_Shipping_Zone.view.component)}
          />

          <Route path={Store_Shipping_Zone.regist.endpoint} exact
            component={checkAuthorization(Store_Shipping_Zone.regist, Store_Shipping_Zone.regist.component)}
          />

          <Route path={Store_Shipping_Country.list.endpoint} exact
            component={checkAuthorization(Store_Shipping_Country.list, Store_Shipping_Country.list.component)}
          />

          <Route path={Store_Shipping_Country.view.endpoint} exact
            component={checkAuthorization(Store_Shipping_Country.view, Store_Shipping_Country.view.component)}
          />

          <Route path={Store_Shipping_Country.regist.endpoint} exact
            component={checkAuthorization(Store_Shipping_Country.regist, Store_Shipping_Country.regist.component)}
          />

          <Route path={Store_Taxe.list.endpoint} exact
            component={checkAuthorization(Store_Taxe.list, Store_Taxe.list.component)}
          />

          <Route path={Store_Taxe.view.endpoint} exact
            component={checkAuthorization(Store_Taxe.view, Store_Taxe.view.component)}
          />

          <Route path={Store_Taxe.regist.endpoint} exact
            component={checkAuthorization(Store_Taxe.regist, Store_Taxe.regist.component)}
          />





          <Route path={Estancia_Config.regist.endpoint} exact
            component={checkAuthorization(Estancia_Config.regist, Estancia_Config.regist.component)}
          />

          <Route path={Estancia_Meios.list.endpoint} exact
            component={checkAuthorization(Estancia_Meios.list, Estancia_Meios.list.component)}
          />

          <Route path={Estancia_Meios.view.endpoint} exact
            component={checkAuthorization(Estancia_Meios.view, Estancia_Meios.view.component)}
          />

          <Route path={Estancia_Meios.regist.endpoint} exact
            component={checkAuthorization(Estancia_Meios.regist, Estancia_Meios.regist.component)}
          />

          <Route path={Estancia_Pista.list.endpoint} exact
            component={checkAuthorization(Estancia_Pista.list, Estancia_Pista.list.component)}
          />

          <Route path={Estancia_Pista.view.endpoint} exact
            component={checkAuthorization(Estancia_Pista.view, Estancia_Pista.view.component)}
          />

          <Route path={Estancia_Pista.regist.endpoint} exact
            component={checkAuthorization(Estancia_Pista.regist, Estancia_Pista.regist.component)}
          />

          <Route path={Estancia_Forfait.list.endpoint} exact
            component={checkAuthorization(Estancia_Forfait.list, Estancia_Forfait.list.component)}
          />

          <Route path={Estancia_Forfait.view.endpoint} exact
            component={checkAuthorization(Estancia_Forfait.view, Estancia_Forfait.view.component)}
          />

          <Route path={Estancia_Forfait.regist.endpoint} exact
            component={checkAuthorization(Estancia_Forfait.regist, Estancia_Forfait.regist.component)}
          />

          <Route path={Estancia_Equipamento.list.endpoint} exact
            component={checkAuthorization(Estancia_Equipamento.list, Estancia_Equipamento.list.component)}
          />

          <Route path={Estancia_Equipamento.view.endpoint} exact
            component={checkAuthorization(Estancia_Equipamento.view, Estancia_Equipamento.view.component)}
          />

          <Route path={Estancia_Equipamento.regist.endpoint} exact
            component={checkAuthorization(Estancia_Equipamento.regist, Estancia_Equipamento.regist.component)}
          />

          <Route path={Estancia_Voucher.list.endpoint} exact
            component={checkAuthorization(Estancia_Voucher.list, Estancia_Voucher.list.component)}
          />

          <Route path={Estancia_Voucher.view.endpoint} exact
            component={checkAuthorization(Estancia_Voucher.view, Estancia_Voucher.view.component)}
          />

          <Route path={Estancia_Voucher.regist.endpoint} exact
            component={checkAuthorization(Estancia_Voucher.regist, Estancia_Voucher.regist.component)}
          />

          <Route path={Estancia_Pack.list.endpoint} exact
            component={checkAuthorization(Estancia_Pack.list, Estancia_Pack.list.component)}
          />

          <Route path={Estancia_Pack.view.endpoint} exact
            component={checkAuthorization(Estancia_Pack.view, Estancia_Pack.view.component)}
          />

          <Route path={Estancia_Pack.regist.endpoint} exact
            component={checkAuthorization(Estancia_Pack.regist, Estancia_Pack.regist.component)}
          />

          <Route path={Estancia_Aula.list.endpoint} exact
            component={checkAuthorization(Estancia_Aula.list, Estancia_Aula.list.component)}
          />

          <Route path={Estancia_Aula.view.endpoint} exact
            component={checkAuthorization(Estancia_Aula.view, Estancia_Aula.view.component)}
          />

          <Route path={Estancia_Aula.regist.endpoint} exact
            component={checkAuthorization(Estancia_Aula.regist, Estancia_Aula.regist.component)}
          />

          <Route path={Estancia_Aula.schedule.endpoint} exact
            component={checkAuthorization(Estancia_Aula.schedule, Estancia_Aula.schedule.component)}
          />

          <Route path={Estancia_AulaInfo.list.endpoint} exact
            component={checkAuthorization(Estancia_AulaInfo.list, Estancia_AulaInfo.list.component)}
          />

          <Route path={Estancia_AulaInfo.view.endpoint} exact
            component={checkAuthorization(Estancia_AulaInfo.view, Estancia_AulaInfo.view.component)}
          />

          <Route path={Estancia_AulaInfo.regist.endpoint} exact
            component={checkAuthorization(Estancia_AulaInfo.regist, Estancia_AulaInfo.regist.component)}
          />

          <Route path={Estancia_Zona.list.endpoint} exact
            component={checkAuthorization(Estancia_Zona.list, Estancia_Zona.list.component)}
          />

          <Route path={Estancia_Zona.view.endpoint} exact
            component={checkAuthorization(Estancia_Zona.view, Estancia_Zona.view.component)}
          />

          <Route path={Estancia_Zona.regist.endpoint} exact
            component={checkAuthorization(Estancia_Zona.regist, Estancia_Zona.regist.component)}
          />

          <Route path={Estancia_Atividade.list.endpoint} exact
            component={checkAuthorization(Estancia_Atividade.list, Estancia_Atividade.list.component)}
          />

          <Route path={Estancia_Atividade.view.endpoint} exact
            component={checkAuthorization(Estancia_Atividade.view, Estancia_Atividade.view.component)}
          />

          <Route path={Estancia_Atividade.regist.endpoint} exact
            component={checkAuthorization(Estancia_Atividade.regist, Estancia_Atividade.regist.component)}
          />

          <Route path={Estancia_PurchaseOrder.list.endpoint} exact
            component={checkAuthorization(Estancia_PurchaseOrder.list, Estancia_PurchaseOrder.list.component)}
          />

          <Route path={Estancia_PurchaseOrder.view.endpoint} exact
            component={checkAuthorization(Estancia_PurchaseOrder.view, Estancia_PurchaseOrder.view.component)}
          />

          <Route path={Estancia_PurchaseOrder.regist.endpoint} exact
            component={checkAuthorization(Estancia_PurchaseOrder.regist, Estancia_PurchaseOrder.regist.component)}
          />

          <Route path={Estancia_PurchaseOrderPaied.list.endpoint} exact
            component={checkAuthorization(Estancia_PurchaseOrderPaied.list, Estancia_PurchaseOrderPaied.list.component)}
          />

          <Route path={Estancia_PurchaseOrderPaied.view.endpoint} exact
            component={checkAuthorization(Estancia_PurchaseOrderPaied.view, Estancia_PurchaseOrderPaied.view.component)}
          />

          <Route path={Estancia_PurchaseOrderPaied.regist.endpoint} exact
            component={checkAuthorization(Estancia_PurchaseOrderPaied.regist, Estancia_PurchaseOrderPaied.regist.component)}
          />

          <Route path={Estancia_PurchaseOrderUsed.list.endpoint} exact
            component={checkAuthorization(Estancia_PurchaseOrderUsed.list, Estancia_PurchaseOrderUsed.list.component)}
          />

          <Route path={Estancia_PurchaseOrderUsed.view.endpoint} exact
            component={checkAuthorization(Estancia_PurchaseOrderUsed.view, Estancia_PurchaseOrderUsed.view.component)}
          />

          <Route path={Estancia_PurchaseOrderUsed.regist.endpoint} exact
            component={checkAuthorization(Estancia_PurchaseOrderUsed.regist, Estancia_PurchaseOrderUsed.regist.component)}
          />

          <Route path={Estancia_PurchaseOrderNotUsed.list.endpoint} exact
            component={checkAuthorization(Estancia_PurchaseOrderNotUsed.list, Estancia_PurchaseOrderNotUsed.list.component)}
          />

          <Route path={Estancia_PurchaseOrderNotUsed.view.endpoint} exact
            component={checkAuthorization(Estancia_PurchaseOrderNotUsed.view, Estancia_PurchaseOrderNotUsed.view.component)}
          />

          <Route path={Estancia_PurchaseOrderNotUsed.regist.endpoint} exact
            component={checkAuthorization(Estancia_PurchaseOrderNotUsed.regist, Estancia_PurchaseOrderNotUsed.regist.component)}
          />

          <Route path={Estancia_Oferta.list.endpoint} exact
            component={checkAuthorization(Estancia_Oferta.list, Estancia_Oferta.list.component)}
          />

          <Route path={Estancia_Oferta.view.endpoint} exact
            component={checkAuthorization(Estancia_Oferta.view, Estancia_Oferta.view.component)}
          />

          <Route path={Estancia_Oferta.regist.endpoint} exact
            component={checkAuthorization(Estancia_Oferta.regist, Estancia_Oferta.regist.component)}
          />





          {/*   <Route path="/" exact component={Main} />Main */}

          <Route path={Main.view.endpoint} exact component={Main.view.component} />

          {/* <Route path="/corporate" exact component={
            checkAuthorization("/corporate", Corporate)
          } /> */}

          <Route path="/terms_conditions" exact component={
            checkAuthorization("/terms_conditions", TermosCondicoes)
          } />

          <Route path="/privacy_policy" exact component={
            checkAuthorization("/privacy_policy", PoliticaPrivacidade)
          } />

          <Route path="/recovery" exact component={Recuperar} />



          <Route path={Perfil.regist.endpoint} exact
            component={checkAuthorization(Perfil.regist.endpoint, Perfil.regist.component)} />

          <Route path={Perfil.list.endpoint} exact
            component={checkAuthorization(Perfil.list.endpoint, Perfil.list.component)} />

          <Route path={Perfil.view.endpoint} exact
            component={checkAuthorization(Perfil.view.endpoint, Perfil.view.component)} />




          {/* QUANDO O ENDEREÇO NÃO É VÝLIDO */}
          {/* <Route path='*' component={() => <Redirect to="/" />} /> */}
          <Route path='*' component={() => <Redirect to="/" />} />

        </Switch >
      </div >
      <Footer />

    </>

}

export default App;


/*

    <Route path="/corporate" exact={true} component={Corporate} />
             <Corporate inputsContent={CorporateContent} onSubmit={() => //console.log('oiiiiiiiiiiiii')} />    </Route>


        <Route path="/user" exact>
          <User inputsContent={UserContent} onSubmit={() => //console.log('oiiiiiiiiiiiii')} />
        </Route>

        <Route path="/preferences" >
          <Preferences />
        </Route>

        <Route path="/datatable">
          <DataTable
                                    noDataComponent='Sem Registos'Example />
        </Route>

        <Route path="/datatable2">
          <DataTable
                                    noDataComponent='Sem Registos'Example2 />
        </Route>

        <Route path="/form">
          <FormTemplate inputsContent={FormContent} onSubmit={() => //console.log('oiiiiiiiiiiiii')} />
        </Route>
        */


/*

import ColaboradorLista from './components/Colaborador/ColaboradorLista';
import Colaborador from './components/Colaborador/Colaborador';
import ColaboradorView from './components/Colaborador/ColaboradorView';

import PromotorLista from './components/Promotor/PromotorLista';
import Promotor from './components/Promotor/Promotor';
import PromotorView from './components/Promotor/PromotorView';

import EscritorioLista from './components/Escritorio/EscritorioLista';
import Escritorio from './components/Escritorio/Escritorio';
import EscritorioView from './components/Escritorio/EscritorioView';

import MasterBlank from './components/Master/MasterBlank';
import MasterLista from './components/Master/MasterLista';
import Master from './components/Master/Master';

*/